module.exports = __webpack_public_path__ + "img/discover_top.15babe4d.png";